import { useTheme } from "../App";

export const useThemedIcon = () => {
  const { theme } = useTheme();

  // Helper to resolve "system" to actual display theme
  const getActualTheme = (): "light" | "dark" => {
    if (theme === "system") {
      // Check system preference
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return theme as "light" | "dark";
  };

  const getIcon = (lightIcon: string, darkIcon: string) => {
    const actualTheme = getActualTheme();
    return actualTheme === "dark" ? darkIcon : lightIcon;
  };

  return { getIcon, theme };
};